import { render } from "./FacultyForm.vue?vue&type=template&id=74514370&scoped=true"
import script from "./FacultyForm.vue?vue&type=script&lang=js"
export * from "./FacultyForm.vue?vue&type=script&lang=js"

import "../css/UniversityForm.css?vue&type=style&index=0&id=74514370&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74514370"]])

export default __exports__